// extracted by mini-css-extract-plugin
export default {"textareaContainer":"CustomTextarea_textareaContainer__qhm-G","textarea":"CustomTextarea_textarea__l-OI1"};